import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class EnAvantMarche extends ActionCard {
    static typeId = "EN_AVANT_MARCHE";
    static cardName = "En Avant Marche";
    static colorHex = "#FFAA00";
    static countInDeck = ACTION_CARD_COUNTS.EN_AVANT_MARCHE;
    static description = "Déplacez toute la ligne d’un emplacement vers l’avant. La première carte est remise sous la pile et une nouvelle vient occuper le dernier emplacement";

    isValidOn(slotIndex, gameState) {
        // Alway valid on any slot
        return true;
    }

    resolve(slotIndex, gameState) {
        gameState.forwardMarch();
    }
}
